import React from "react";
import { useMediaQuery } from "react-responsive";

import { GradientOverlay, NormalOverlay } from "@components/item/Overlays";
import { SecondaryButton } from "@components/buttons";
import { ViewDetailsText } from "@utils/lanugauge-settings/static-texts/TranslatedTexts";

export const BoxListFiveDetailButton = ({ onHover, idx, item, url }) => {
  const isDefault = useMediaQuery({ maxWidth: 1199 });

  return (
    <SecondaryButton
      customstyle={{
        display: onHover === idx || isDefault ? "flex" : "none",
        opacity: onHover === idx || isDefault ? 1 : 0,
        width: "100%",
      }}
      buttonColor="white"
      linkTo={`${url}${item.url_alias}`}
    >
      <ViewDetailsText />
    </SecondaryButton>
  );
};

export const BoxListFiveOverlays = ({ onHover, idx }) => {
  const isDefault = useMediaQuery({ maxWidth: 1199 });

  return (
    <>
      <NormalOverlay
        rgb="104, 80, 124"
        opacity={isDefault ? 0 : onHover === idx ? 0.6 : 0}
      />

      <GradientOverlay
        opacity={isDefault ? 0.85 : onHover === idx ? 0 : 0.6}
        direction="to top"
      />
    </>
  );
};
